import { createFileRoute } from '@tanstack/react-router';
import { PlatformLayout } from '@/features/shell/platform-layout';

export const Route = createFileRoute('/_app/_platform')({ component: PlatformLayout });
